export default __webpack_public_path__ + "media/images/error-centre-f14430ede81cc0b2565315dcc6b76204.png";